import { ReactElement, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { hasPermissions, TabsContainer } from "@ps/ui-components";
import { dashConverter, getSlug, permissionsMappers } from "@ps/utils";
import { FINANCE_TABS, NAMESPACE } from "../../shared/constants";
import { FINANCES } from "../../shared/routes";
import { useMappedStateSelector } from "../../hooks";
import {
  FinanceContainerProps,
  FinanceContainerMapState,
  FinanceContainerMapStateReturn,
} from "./types";

const FinanceContainer = ({
  children,
}: FinanceContainerProps): ReactElement => {
  const history = useHistory();
  const { pathname } = useLocation();

  const defaultTab =
    getSlug(dashConverter(pathname)) === "finance"
      ? FINANCES
      : getSlug(dashConverter(pathname));

  const [activeTab, setActiveTab] = useState<string>(defaultTab);

  const mapState = (
    state: FinanceContainerMapState,
  ): FinanceContainerMapStateReturn => ({
    editMode: state.editMode,
    allPermissions: state.permissions || [],
  });

  useEffect(() => {
    setActiveTab(getSlug(dashConverter(pathname)));
  }, [pathname, activeTab]);

  const { editMode } = useMappedStateSelector(mapState);
  const { allPermissions } = useMappedStateSelector(mapState, "");

  const handleOnTabChange = (path: string): void => {
    history.listen(() => setActiveTab(path));
    history.push(`/finance/${path}`);
    if (!editMode) setActiveTab(path);
  };

  return (
    <TabsContainer
      activeTab={activeTab}
      handleOnTabChange={handleOnTabChange}
      prefix={`${NAMESPACE}_finance`}
      tabs={permissionsMappers.filterTabsWithPermissions(
        FINANCE_TABS,
        hasPermissions,
        allPermissions,
      )}
      translationID={NAMESPACE}
      translationPath="finance.tabs"
    >
      <section className="h-full">{children}</section>
    </TabsContainer>
  );
};

export default FinanceContainer;
